import {useEffect, useRef} from "react";

export const useDateSelection = ({
  delivery,
  rule,
  fromSettings,
  periodicity,
  setDates,
  setIsLoadingUpcomingDates,
}) => {
  const mounted = useRef(true);
  const requestInProgress = useRef(false);

  useEffect(() => {
    return () => {
      mounted.current = false;
    };
  }, []);

  const fetchUpcomingDates = async (selectedPeriodicity = null) => {
    if (!delivery || periodicity === "ONCE" || selectedPeriodicity === "ONCE") return;
    if (!mounted.current || requestInProgress.current) return;

    requestInProgress.current = true;
    setIsLoadingUpcomingDates(true);

    setDates(Array(4).fill({ date: "", original_date: "", selected: false }));

    try {
      const deliveryId = delivery.id;
      const subscriptionId = delivery.subscription.id;
      let ruleProductUrl = `/api/rule-product/upcoming_dates/?delivery_id=${deliveryId}&subscription_id=${subscriptionId}&from_settings=${
        fromSettings ? "true" : "false"
      }`;

      if (selectedPeriodicity) {
        const periodicityEncoded = encodeURIComponent(selectedPeriodicity);
        ruleProductUrl += `&periodicity=${periodicityEncoded}`;
      } else if (rule?.id) {
        ruleProductUrl += `&rule_id=${rule.id}`;
      } else if (periodicity) {
        const periodicityEncoded = encodeURIComponent(periodicity);
        ruleProductUrl += `&periodicity=${periodicityEncoded}`;
      } else {
        requestInProgress.current = false;
        setIsLoadingUpcomingDates(false);
        return;
      }

      if (rule === undefined || rule?.is_temporary) {
        ruleProductUrl += `&is_temporary=true`;
      }

      const response = await fetch(ruleProductUrl);
      if (!response.ok) {
        console.error("Failed to fetch upcoming dates:", response.statusText);
        requestInProgress.current = false;
        return;
      }

      const data = await response.json();
      if (mounted.current) {
        setDates(data.dates);
      }
    } catch (error) {
      console.error("Error fetching upcoming dates:", error);
    } finally {
      if (mounted.current) {
        setIsLoadingUpcomingDates(false);
      }
      requestInProgress.current = false;
    }
  };

  return { fetchUpcomingDates };
};
